import { useEffect, useRef } from 'react';

const DiscussionListeners = ({ eventEmitter, applyStoreAction, currentUserId }) => {
    const currentUserIdRef = useRef(currentUserId);

    useEffect(() => {
        currentUserIdRef.current = currentUserId;
    }, [currentUserId]);

    const listen = () => {
        eventEmitter.on('chat_created', discussion => {
            if (discussion.members.map(user => user.id || user).includes(currentUserIdRef.current)) {
                applyStoreAction({
                    type: 'DISCUSSION_ADD_SOCKET',
                    payload: {
                        discussion
                    }
                });
            }
        });

        eventEmitter.on('chat_removed', discussion => {
            applyStoreAction({
                type: 'DISCUSSION_REMOVE_SOCKET',
                payload: { discussionId: discussion.id }
            });
        });

        eventEmitter.on('thread_create', discussion => {
            if (discussion.invitees.map(user => user.id || user).includes(currentUserIdRef.current)) {
                applyStoreAction({
                    type: 'DISCUSSION_ADD_SOCKET',
                    payload: {
                        discussion
                    }
                });
            }
        });

        eventEmitter.on('chat_edited', discussion => {
            applyStoreAction({
                type: 'DISCUSSION_UPDATE_SOCKET',
                payload: {
                    discussionId: discussion.id,
                    discussion
                }
            });
        });

        eventEmitter.on('chat_muted', ({ chat_id: discussionId, for: userId }) => {
            applyStoreAction({
                type: 'DISCUSSION_MUTE_SOCKET',
                payload: { discussionId, userId }
            });
        });

        eventEmitter.on('chat_unmuted', ({ chat_id: discussionId, for: userId }) => {
            applyStoreAction({
                type: 'DISCUSSION_UNMUTE_SOCKET',
                payload: { discussionId, userId }
            });
        });

        eventEmitter.on('user_left', payload => {
            applyStoreAction({
                type: 'DISCUSSION_LEAVE_SOCKET',
                payload: {
                    discussionId: payload.discussion_id || payload.chat_id,
                    userId: payload.user_id
                }
            });
        });

        eventEmitter.on('chat_leave', ({ chat_id: discussionId, member: userId }) => {
            applyStoreAction({
                type: 'DISCUSSION_LEAVE_SOCKET',
                payload: {
                    discussionId,
                    userId,
                    self: userId === currentUserIdRef.current
                }
            });
        });

        eventEmitter.on('chat_kicked', ({ chat_id: discussionId }) => {
            applyStoreAction({
                type: 'DISCUSSION_KICK_SOCKET',
                payload: {
                    discussionId
                }
            });
        });

    }

    useEffect(listen, []);

    return null;
}

export default DiscussionListeners;
